import antdEnUS from 'antd/es/locale/en_US';

const EnLang = {
  antd: antdEnUS,
  locale: 'en-US',
  messages: {
  },
};
export default EnLang;
